// Unpublished Work © 2020-2024 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import {Dialog} from '@deere/isg.component-library';
import {connect} from 'react-redux';
import LoadingWrapper from 'Ui/components/common/loading-wrapper';

function footerActions(props) {
    const continueButton = {
        onClick: props.onContinue,
        variant: 'primary',
        disabled: props.disabled,
        loading: props.showLoadingIcon && props.disabled,
        title: props.continueTitle ? props.continueTitle : props.translations.yes
    };
    const cancelButton = {
        onClick: props.onCancel,
        variant: 'secondary',
        disabled: props.disabled,
        title: props.cancelTitle ? props.cancelTitle : props.translations.no
    };

    return [cancelButton, continueButton];
}

function ConfirmationDialog(props) {
    const [disabled, setDisabled] = React.useState(false);

    const footerActionProps = {
        ...props,
        disabled,
        onContinue() {
            setDisabled(true);
            props.onContinue();
        }
    };

    return (
        <Dialog
            className='confirmation-dialog'
            closeHandler={props.onCancel}
            footerActions={footerActions(footerActionProps)}
            open={true}
            title={props.title}
        >
            <LoadingWrapper
                className='table-loading-icon'
                loading={disabled}
                size='50px'
            >
                {props.message}
            </LoadingWrapper>
        </Dialog>
    );
}

ConfirmationDialog.defaultProps = {
    showLoadingIcon: false
};

ConfirmationDialog.propTypes = {
    message: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.string
    ]),
    onCancel: PropTypes.func,
    onContinue: PropTypes.func,
    showLoadingIcon: PropTypes.bool,
    title: PropTypes.string,
    translations: PropTypes.translations
};

export function mapStateToProps(state) {
    return {
        translations: state.translations
    };
}

export default connect(mapStateToProps)(ConfirmationDialog);
